import React from 'react';

class Footer extends React.Component {

	render() {
		return(
			<footer className='common-footer'>
				<p>©{(new Date().getFullYear())} Velocity powered by  <a href="https://www.cyncly.com/" target="_blank" rel="noopener noreferrer">Cyncly.</a> All Rights Reserved.</p>
			</footer>
		);
	}

}

export default Footer;